<template>
  <div class="sf-row">
    <div class="sf-col sf-xs-12 sf-sm-3">
      <div id="adjustments-selective-copy-sidebar">
        <AdjustmentsSidebar
          :copy-type="copyType"
          :current-ledger-period-name="currentLedgerPeriodName"
          :total-replaced-html="totalReplacedHtml"
        />
      </div>
    </div>
    <div class="sf-col sf-xs-12 sf-sm-9">
      <AdjustmentsContent :copy-type="copyType" :form-action="formAction" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { onBeforeMount } from 'vue'

import { useAdjustmentsStore } from '../store'

import AdjustmentsSidebar from './adjustments-sidebar.vue'
import AdjustmentsContent from './adjustments-content.vue'

defineOptions({
  name: 'AdjustmentsSelectiveCopy',
})

interface Props {
  categories: Array<{ id: number; name: string }>
  copyTypes: Array<{ id: string; name: string }>
  copyType: 'forward' | 'reverse' | 'normal'
  currentLedgerPeriodName: string
  formAction: string
  forwardAccounts: Array<{ id: number; name: string }>
  ledgers: Array<{ id: number; period_name: string }>
  tags: Array<{ id: number; name: string }>
  totalReplacedHtml: string
}

const props = defineProps<Props>()

const adjustmentsStore = useAdjustmentsStore()

const { receiveInitialData } = adjustmentsStore

onBeforeMount(() => {
  receiveInitialData({
    categories: props.categories,
    copyType: props.copyType,
    copyTypes: props.copyTypes,
    forwardAccounts: props.forwardAccounts,
    ledgers: props.ledgers,
    tags: props.tags,
  })
})
</script>
